import React from "react";
import ModalWrapper from "./ModalWrapper";
import PropTypes from "prop-types";
import { confirmable } from "react-confirm";
import { createConfirmation } from "react-confirm";
const ChooseSeason = ({ show, proceed, options = {} }) => {
  if (show) {
    return (
      <ModalWrapper
        clickOff={() => {
          proceed(false);
        }}
      >
        <div
          className={`flex flex-col  rounded-xl bg-snow-white drop-shadow-2xl px-12 pt-6 pb-6 overflow-x-scroll justify-center`}
        >
          <p className="text-2xl font-bold font-snow-primary mb-2 text-center">
            Choose a Season
          </p>
          <p className="mb-2 max-w-[600px] whitespace-pre-wrap text-center">
            {options.description ?? "Pick the season you want to use."}
          </p>
          <div className="flex flex-row flex-1 w-full gap-4 justify-center">
            <button
              onClick={() => proceed("snow")}
              className={`min-w-[100px] border rounded-md p-2 text-sm shadow-sm font-semibold bg-snow-blue-3 hover:bg-sky-700 text-full-white border-snow-blue-3`}
              type="button"
            >
              Snow
            </button>
            <button
              onClick={() => proceed("landscape")}
              className={`min-w-[100px] border rounded-md p-2 text-sm shadow-sm font-semibold bg-landscape-primary hover:bg-landscape-secondary border-landscape-secondary text-full-white `}
              type="button"
            >
              Landscape
            </button>
          </div>
        </div>
      </ModalWrapper>
    );
  }
  return null;
};

ChooseSeason.propTypes = {
  show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  confirmation: PropTypes.string, // arguments of your confirm function
  options: PropTypes.object, // arguments of your confirm function
};

const ChooseSeasonConfirmable = confirmable(ChooseSeason);
const confirm = createConfirmation(ChooseSeasonConfirmable);
export function pickSeason(confirmation, options = {}) {
  return confirm({ confirmation, options });
}
